import Vue from "vue";
import Router from "vue-router";
import { ActiveUser } from "@/services/user";

// Containers
const TheContainer = () => import("@/containers/TheContainer");
const AccountContainer = () => import("@/containers/AccountContainer");

// Views
import Home from "@/views/Home";
import Counterparts from "@/views/Counterparts";
import CriProcess from "@/views/CriProcess";
import Search from "@/views/Search";
import Explore from "@/views/Explore";
import ViolationTracker from "@/views/ViolationTracker";
import Blacklist from "@/views/configuration/Blacklist";
import Whitelist from "@/views/configuration/Whitelist";
import RiskFactors from "@/views/configuration/RiskFactors";

// Views - Pages
const Page404 = () => import("@/views/pages/Page404");
const Login = () => import("@/views/pages/Login");
const ForgotPassword = () => import("@/views/pages/ForgotPassword");
const ResetPassword = () => import("@/views/pages/ResetPassword");

// Users
const Users = () => import("@/views/users/UsersView");
const User = () => import("@/views/users/UserView");

Vue.use(Router);

const router = new Router({
  mode: "history",
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes(),
});

const isOpenAccess = (route) =>
  route.matched.some((route) => route.meta?.isOpenAccess);

const isFound = (route) => route.matched[0].name !== "NotFound";

router.beforeEach((to, from, next) => {
  if (to.meta?.getTitle) to.meta.title = to.meta.getTitle(to);
  const isAuthenticated = ActiveUser.get();
  if (!isAuthenticated && !isOpenAccess(to)) {
    if (isFound(to)) {
      localStorage.setItem("pathToLoadAfterLogin", to.path);
    }
    return next({ name: "Login" });
  }
  return next();
});
export default router;

function configRoutes() {
  return [
    {
      path: "/",
      redirect: "/home",
      name: "Home",
      component: TheContainer,
      children: [
        {
          path: "home",
          name: "Home",
          component: Home,
        },
        {
          path: "cri-process",
          name: "Cri Process",
          component: CriProcess,
        },
        {
          path: "counterparts",
          name: "Counterparts",
          component: Counterparts,
        },
        {
          path: "search",
          name: "Search",
          component: Search,
        },
        {
          path: "violation-tracker",
          name: "Violation Tracker",
          component: ViolationTracker,
        },
        {
          path: "configuration",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "blacklist",
              name: "Blacklist",
              component: Blacklist,
            },
            {
              path: "whitelist",
              name: "Whitelist",
              component: Whitelist,
            },
            {
              path: "risk-factors",
              name: "Risk Factors",
              component: RiskFactors,
            },
          ],
        },
        {
          path: "explore",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: ":eib",
              name: "Explore",
              component: Explore,
            },
          ],
        },

        {
          path: "users",
          meta: {
            label: "Users",
          },
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "Users",
              component: Users,
            },
            {
              path: ":id",
              meta: {
                label: "User Details",
              },
              name: "User",
              component: User,
            },
          ],
        },
      ],
    },
    {
      path: "/oauth",
      meta: {
        isOpenAccess: true,
      },
      component: AccountContainer,
      children: [
        {
          path: "",
          name: "OAuth Login",
          component: Login,
        },
      ],
    },
    {
      path: "/account",
      name: "account",
      meta: {
        isOpenAccess: true,
      },
      component: AccountContainer,
      children: [
        {
          path: "login",
          name: "Login",
          component: Login,
        },
        {
          path: "forgot",
          name: "Forgot password",
          component: ForgotPassword,
        },
        {
          path: "reset/:token",
          name: "Password reset",
          component: ResetPassword,
        },
        {
          path: "login_management",
          name: "Management Login",
          component: Login,
          props: {
            show_email_login: true,
          },
        },
      ],
    },
    {
      path: "/pages",
      redirect: "/pages/404",
      name: "Pages",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "404",
          name: "Page404",
          component: Page404,
        },
      ],
    },
    {
      path: "*",
      name: "NotFound",
      component: TheContainer,
      children: [{ path: "*", component: Page404 }],
    },
  ];
}
